import RoyaltyStatementControllerClass from "./RoyaltyStatementController";
import PurchaseReportControllerClass from "./PurchaseReportController";
import CustomersReportControllerClass from "./CustomersReportController";
import PackagesReportControllerClass from "./PackagesReportController";
import PetsReportControllerClass from "./PetsReportController";

let CRoyaltyStatement = null;
let CPurchaseReport = null;
let CCustomersReport = null;
let CPackagesReport = null;
let CPetsReport = null;

export function RoyaltyStatementController() {
  if (CRoyaltyStatement) {
    return CRoyaltyStatement;
  }

  CRoyaltyStatement = new RoyaltyStatementControllerClass();
  return CRoyaltyStatement;
}

export function PurchaseReportController() {
  if (CPurchaseReport) {
    return CPurchaseReport;
  }

  CPurchaseReport = new PurchaseReportControllerClass();
  return CPurchaseReport;
}

export function CustomersReportController() {
  if (CCustomersReport) {
    return CCustomersReport;
  }

  CCustomersReport = new CustomersReportControllerClass();
  return CCustomersReport;
}

export function PetsReportController() {
  if (CPetsReport) {
    return CPetsReport;
  }

  CPetsReport = new PetsReportControllerClass();
  return CPetsReport;
}

export function PackagesReportController() {
  if (CPackagesReport) {
    return CPackagesReport;
  }

  CPackagesReport = new PackagesReportControllerClass();
  return CPackagesReport;
}
